const Section = ({ children, rightAction, title, className }) => {
  return (
    <div className={`ew-px-16 ew-mt-24 ${className || ''}`}>
      <div className='ew-d-flex ew-justify-content-between ew-align-items-center ew-pb-8'>
        <span className='ew-typography-normal ew-fw-semi-bold ew-color-secondary'>{title}</span>
        {rightAction || null}
      </div>
      {children}
    </div>
  )
}

export default Section
